import { baseApi } from './baseApi'

export const assetsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAssetsList: builder.query<{ filenames: string[] }, { bucket?: string; folder?: string }>({
      query: (params) => ({
        url: `/lab/assets/list`,
        params,
      }),
    }),
  }),
})

export const { useGetAssetsListQuery, useLazyGetAssetsListQuery } = assetsApi

